<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp;Riwayat Pengecekan</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4">Riwayat Pengecekan</h5>
              <!-- Searchbar -->
              <div class="col-lg-12 px-0">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-4 col-sm mobile-div pl-0">
                      <div>Nama Perusahaan</div>
                      <input type="text" class="form-control" name="search_value" placeholder="Nama Perusahaan" v-model="companySearch">
                    </div>
                    <div class="col-lg-3 col-sm mobile-div pl-0">
                      <div>Urutkan</div>
                      <select name="ordering" id="ordering" class="form-control" v-model="ordering">
                        <option value="All" selected>Semua</option>
                        <option value="Unik - Terbaru">Unik - Terbaru</option>
                      </select>
                    </div>
                    <div class="col-lg-3 col-sm mobile-div pl-0">
                      <div>Golongan Skor</div>
                      <select name="ordering" id="ordering" class="form-control" v-model="score">
                        <option value="All" selected>Semua</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                    <div class="col-lg-2 px-0 col-sm mobile-div mt-4">
                      <button class="btn btn-primary" @click="getData"> Search </button>
                    </div>
                  </div>
                  <p class="text-danger" v-if="dataFound == false && companySearch.length > 0 && searched == true">Perusahaan tidak ditemukan</p>
                </div>
              </div>
              <!-- Table Data -->
              <table class="table table-sm table-bordered table-striped table-responsive-sm mt-5">
                <thead>
                  <tr>
                    <th>Nama Perusahaan</th>
                    <th class="col-1">Golongan</th>
                    <th>Tgl. Kalkulasi</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingTable == true">
                    <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                  </tr>
                  <tr v-else-if="loadingTable == false && historyData.length" v-for="(comp,i) in historyData" :key="i">
                    <td>
                      {{comp.company_name}}
                    </td>
                    <td>
                      {{comp.score}}
                    </td>
                    <td>
                      {{comp.createdAt}}
                    </td>
                    <td class="text-center">
                      <div class="mb-2">
                        <button class="btn btn-info" @click.prevent="$router.push('/risk-management/detail/' + comp.id)">Lihat</button>
                      </div>
                    </td>
                  </tr>
                  <tr v-else-if="loadingTable == false && !historyData.length">
                    <td colspan="5" class="text-center">Data not found.</td>
                  </tr>
                </tbody>
              </table>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="getData">
                      <option :value="10">10</option>
                      <option :value="40">40</option>
                      <option :value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2" v-if="totalPage > 0">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(page-1)" v-if="page != 0">
                        <li>{{'<'}}</li> 
                      </a> 
                      <a class="page">
                        <li>{{ page + 1 }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(page + 1)" v-if="page + 1 < totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SideBar from '../SideBar'
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect';
export default {
  name: 'RiwayatCek',
  components: {
    SideBar,
    Multiselect
  },
  data() {

    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin: '',
      permission: [],
      loadingTable: false,
      itemPerPage: 10,
      totalData: 0,
      page: 0,
      totalPage: 0,
      companySearch: '',
      score: 'All',
      ordering: 'All',
      dataFound: true,
      historyData: [],
      viewEmployee: true
    }
  },
  methods: {
    getData() {
      console.log('itemperpage', this.itemPerPage)
      this.loadingTable = true
      let order = ''
      let sc = ''
      if (this.score == 'All') sc = ''
      else sc = this.score
      if (this.ordering == 'All') order = ''
      else order = this.ordering
      this.$http.post(process.env.SEARCH_HISTORY, {
          companyName: this.companySearch.replace(this.spaceRegex, ' '),
          ordering: order,
          score: sc.replace(this.spaceRegex, ' '),
          page: +this.page + 1,
          itemPerPage: this.itemPerPage
        }, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.loadingTable = false
            this.page = res.data.content.currentPage - 1
            this.historyData = res.data.content.data
            this.totalData = res.data.content.totalData
            this.totalPage = res.data.content.totalPage
          } else if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
          localStorage.setItem('history-cache', JSON.stringify({ itemPerPage: this.itemPerPage, page: this.page, ordering: this.ordering, score: this.score, companySearch: this.companySearch }))
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    // async getData() {
    //   try {
    //     this.loadingTable = true
    //     let res = await this.$http.post('https://api-dashboard-dev.asani.co.id/risk/search', {
    //       companyName: this.companySearch,
    //       ordering: this.ordering,
    //       score: this.score,
    //       page: this.page,
    //       itemPerPage: this.itemPerPage
    //     }, {
    //       headers: {
    //         "Asani-Token": localStorage.getItem("jwt")
    //       }
    //     })
    //     if (res) {
    //       console.log(res)
    //       if (res.data.status == 200) {
    //         this.loadingTable = false
    //         this.page = res.data.content.currentPage
    //         this.historyData = res.data.content.data
    //         this.totalData = res.data.content.totalData
    //         this.totalPage = res.data.content.totalPage
    //       }
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    toDataPage(val) {
      this.page = val
      window.scrollTo(0, 0)
      localStorage.setItem('history-cache', JSON.stringify({ itemPerPage: this.itemPerPage, page: this.page, ordering: this.ordering, score: this.score, companySearch: this.companySearch }))
      window.location.reload()
    },
    toPage(e) {
      this.$router.push(e)
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    if (localStorage.getItem('history-cache')) {
      let cache = JSON.parse(localStorage.getItem('history-cache'))
      this.page = cache.page
      this.itemPerPage = cache.itemPerPage
      this.companySearch = cache.companySearch
      this.ordering = cache.ordering,
        this.score = cache.score
    }
    this.cekLogin()
    this.cekPermission()
    this.getData()
  }
}
</script>

<style scoped>
.one-line-sm {
  display: flex;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.redirect-link {
  text-decoration: underline #2797FB;
  cursor: pointer;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/RiskManagement/riwayat.vue